import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, message: null };
    }

    componentDidCatch(error, info) {
        console.error('[ErrorBoundary]', error, info);
        this.setState({ hasError: true, message: error && error.message });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{ maxWidth: 520, margin: '80px auto', padding: '0 20px', textAlign: 'center', fontFamily: 'var(--ng-font, sans-serif)' }}>
                    <div style={{ fontSize: 44, marginBottom: 12 }}>🛠</div>
                    <h1 style={{ fontFamily: 'var(--ng-font-display, serif)', fontWeight: 600, fontSize: 28, margin: '0 0 10px' }}>
                        Something went wrong
                    </h1>
                    <p style={{ color: '#6d746c', fontSize: 15, lineHeight: 1.6 }}>
                        This can happen when the app has been updated while this tab was open.
                        Reloading usually fixes it.
                    </p>
                    {this.state.message ? (
                        <p style={{ color: '#a8ab9f', fontSize: 12.5, fontFamily: 'monospace', margin: '14px 0' }}>
                            {String(this.state.message).slice(0, 200)}
                        </p>
                    ) : null}
                    <button
                        className="ng-btn ng-btn-primary"
                        style={{ marginTop: 10 }}
                        onClick={() => window.location.reload(true)}
                    >
                        Reload the app
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
